import { FC, ReactNode } from 'react';
import { List, Box, Flex, useColorModeValue } from '@chakra-ui/react';
import { SkewBox } from './SkewBox';
import { StepContent } from './StepContent';
export interface StepProps {
  isCurrent: boolean;
  handleStep?: () => void;
  children?: ReactNode;
}
export const Step: FC<StepProps> = ({
  isCurrent,
  handleStep,
  children
}) => {
  const color = useColorModeValue('white', 'gray.900');
  return <List flex="1" onClick={handleStep} data-sentry-element="List" data-sentry-component="Step" data-sentry-source-file="Step.tsx">
      <Box as="button" outline={0} className="group" width="full" data-sentry-element="Box" data-sentry-source-file="Step.tsx">
        <Flex align="center" height="12" justify="center" position="relative" css={{
        '--arrow-skew': '20deg'
      }} data-sentry-element="Flex" data-sentry-source-file="Step.tsx">
          <SkewBox isCurrent={isCurrent} placement="top" data-sentry-element="SkewBox" data-sentry-source-file="Step.tsx" />
          <StepContent color={isCurrent ? color : 'inherit'} data-sentry-element="StepContent" data-sentry-source-file="Step.tsx">
            {children}
          </StepContent>
          <SkewBox isCurrent={isCurrent} placement="bottom" data-sentry-element="SkewBox" data-sentry-source-file="Step.tsx" />
        </Flex>
      </Box>
    </List>;
};